import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CustomerConfigurationResponse } from './customer-configuration.types';
import { ApiService } from './api.service';

@Injectable()
export class CustomerConfigurationService {
  constructor(private baseApiService: ApiService) {}

  fetchCustomerConfiguration(customerBk: string): Observable<CustomerConfigurationResponse> {
    return this.baseApiService.fetchData<null, CustomerConfigurationResponse>(
      `analytics/customer-configuration/customers/${customerBk}`,
      undefined
    );
  }
}
